export class WorkshopConfig {
  prefixWorkshop: string = 'WS-{year}-';
  workshopHeader: string = '';
  workshopFooter: string = '';
  additionalIntakeText: string = '';
  additionalCheckoutText: string = '';
}
